import { messages } from "./messages";
import {
  EMAIL_REGX, PHONE_REGX, NO_NUMBER_REGX, ONLY_NUMBERS_REGX, AT_LEAST_LOWERCASE,
  AT_LEAST_NUMBER, AT_LEAST_SPECIAL_CHAR, AT_LEAST_UPPERCASE, CPF_REGEX, CNPJ_REGEX,
  CR_DOCUMENT, CEP_REGX, SCHEDULE_REGX, DATE_REGX,
} from "./constants";

export const noValidator = () => '';

export const notEmptyValidator = value =>
  !value || (typeof value === 'string' && !value.trim()) ? messages.EMPTY_FIELD : '';

export const emailValidator = value =>
  value && !EMAIL_REGX.test(value) ? messages.INVALID_EMAIL : '';

export const repeatEmailValidator = (a, b) =>
  a !== b ? messages.REPEAT_EMAIL : '';

export const phoneValidator = value =>
  value && !PHONE_REGX.test(value) ? messages.INVALID_PHONE : '';

export const onlyNumberValidator = value =>
  value && !ONLY_NUMBERS_REGX.test(value) ? messages.ONLY_NUMBER : '';

export const addressNumberValidator = value =>
  value && !ONLY_NUMBERS_REGX.test(value) && !NO_NUMBER_REGX.test(value) ? messages.NUMBER_ADDRESS : '';

export const atLeastOneLowerCaseValidator = value =>
  value && !AT_LEAST_LOWERCASE.test(value) ? messages.AT_LEAST_ONE_LOWERCASE : '';

export const atLeastOneUpperCaseValidator = value =>
  value && !AT_LEAST_UPPERCASE.test(value) ? messages.AT_LEAST_ONE_UPPERCASE : '';

export const atLeastOneNumberValidator = value =>
  value && !AT_LEAST_NUMBER.test(value) ? messages.AT_LEAST_ONE_NUMBER : '';

export const atLeastOneSpecialCharValidator = value =>
  value && !AT_LEAST_SPECIAL_CHAR.test(value) ? messages.AT_LEAST_ONE_SPECIAL_CHAR : '';

export const minLengthValidator = length => value =>
  value && value.toString().length < length ? messages.MIN_LENGTH.replace('%%', length) : '';

export const maxLengthValidator = length => value =>
  value && value.toString().length > length ? messages.MAX_LENGTH.replace('%%', length) : '';

export const cpfValidator = value =>
  value && !CPF_REGEX.test(value) ? messages.INVALID_CPF : '';

export const cnpjValidator = value =>
  value && !CNPJ_REGEX.test(value) ? messages.INVALID_CNPJ : '';

export const maxValueValidator = max => value =>
  value && value > max ? messages.MAX_VALUE : '';

export const minValueValidator = min => value =>
  value && value < min ? messages.MIN_VALUE : '';

export const crDocumentValidator = value =>
  value && !CR_DOCUMENT.test(value) ? messages.INVALID_FIELD : '';

export const cepValidator = value =>
  value && !CEP_REGX.test(value) ? messages.INVALID_CEP : '';

export const scheduleValidator = value =>
  value && !SCHEDULE_REGX.test(value) ? messages.INVALID_SCHEDULE : '';

export const dateFormatValidator = value =>
  value && !DATE_REGX.test(value) ? messages.INVALID_DATE : '';

export const validDateValidator = value => {
  if (!value) return '';
  const [d,m,y] = value.split("/");
  const date = new Date(`${m}/${d}/${y}`);
  return date instanceof Date && !isNaN(date) ? '' : messages.INVALID_DATE;
}

export const minDateValidator = minDate => value => {
  const date = new Date(minDate.toDateString());
  const inputDate = new Date(`${value}T00:00:00`);
  return value && inputDate < date ? messages.MIN_DATE : '';
}

export const minItemValidator = length => array =>
  array && array.length < length ? messages.MIN_ARRAY_LENGTH.replace('%%', length) : '';
